import { effect, inject, Injectable, signal } from '@angular/core';
import { Pensionsudbyder } from './pensionsudbyder.model';
import { PuSearchParams } from './pu-search/pu-search-params.model';
import { PensionsudbyderHistorikService } from './pu-historik/pu-historik.service';
import { PensionsudbyderDatasource } from '@features/pensionsudbydere/pensionsudbyder.datasource';

@Injectable({
  providedIn: 'root',
})
export class PensionsudbydereService {
  datasource = inject(PensionsudbyderDatasource);

  constructor() {
    effect(() => {
      if (this.datasource.isLoaded()) {
        const data = this.datasource.data();
        if (data && data.totalRowCount > 0) {
          this.activeTab.set('result');
        }
      }
    });
  }

  puHistorikService = inject(PensionsudbyderHistorikService);

  selectedPu = signal<Pensionsudbyder | undefined>(undefined);
  activeTab = signal('search');

  searchPu(searchParams: PuSearchParams) {
    this.selectedPu.set(undefined);
    this.datasource.searchParams.set(searchParams);
    this.datasource.loadData();
  }

  async selectPuResultRow(pensionsudbyder: Pensionsudbyder) {
    await this.selectPensionsudbyder(pensionsudbyder);

    if (pensionsudbyder) {
      this.activeTab.set('detail');
    }
  }

  async selectPensionsudbyder(pensionsudbyder: Pensionsudbyder) {
    const pu = await this.datasource.getById(pensionsudbyder.id!);
    this.selectedPu.set(pu);
    this.puHistorikService.datasource.pensionsudbyderId.set(pensionsudbyder.id);
  }
}
